<template>
  <!-- Topbar Start -->
  <div class="navbar-custom topnav-navbar navbar-backHome">
    <div class="container-fluid">
      <!-- LOGO -->
      <div class="topnav-logo">
        <span class="topnav-logo-lg"><img src="@/assets/images/yf_images/logo_b_l.png" alt="" height="84" /></span>
        <span class="topnav-logo-sm"><img src="@/assets/images/yf_images/logo_b_s.png" alt="" height="84" /></span>
      </div>

      <!-- LOGO右侧菜单 -->
      <ul class="list-unstyled topbar-right-menu float-right mb-0">
        <li class="dropdown notification-list" @click="goFrontDesk">
          <a class="nav-link right-bar-toggle nav-home" href="javascript: void(0);">
            <i class="dripicons-home d-none d-sm-inline-block"></i>
            <span class="align-middle">前台首页</span>
          </a>
        </li>
        <li class="dropdown notification-list d-none d-lg-block" @click="goBackstage">
          <a class="nav-link right-bar-toggle nav-home" href="javascript: void(0);">
            <i class="mdi mdi-bank"></i>
            <span class="align-middle">后台首页</span>
          </a>
        </li>
        <li>
          <Login></Login>
        </li>
      </ul>
    </div>

  </div>
  <!-- end Topbar -->
</template>

<script>
import Login from "@/components/Login";
export default {
  components: { Login },
  data() {
    return {
      isUserLiLook: false,
    };
  },
  created() {},
  methods: {
    goFrontDesk() {
			let routeUrl = this.$router.resolve({
			   path: "/",
			});
			window.open(routeUrl.href, '_blank');
    },
    goBackstage() {
			let routeUrl = this.$router.resolve({
			   path: "/backstage/index",
			});
			window.open(routeUrl.href, '_blank');
    },
  },
};
</script>

<style scoped></style>
